import { render, staticRenderFns } from "./GebruikersIndex.vue?vue&type=template&id=2e253137&scoped=true&"
import script from "./GebruikersIndex.vue?vue&type=script&lang=js&"
export * from "./GebruikersIndex.vue?vue&type=script&lang=js&"
import style0 from "./GebruikersIndex.vue?vue&type=style&index=0&id=2e253137&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e253137",
  null
  
)

export default component.exports